import { EnumSelectField } from '@mews-commander/form';
import { FormInputField, lt } from '@mews/framework';
import { SpacingToken, Stack } from '@optimus-web/core';
import { RoutingRuleTriggerType } from '@mews-commander/data-access';
import { SearchType } from '@mews-commander/enums';
import { RoutingRulesListFilterSchemaKeys } from '../schemas/routingRulesListFilterSchema';
import { SearchHookField } from '../../../components/form/hookFields';

const FILTERS_SPACING: SpacingToken = '300';

interface RoutingRuleListFiltersProps {
    displayLegacy: boolean;
}

export const RoutingRuleListFilters: React.FC<RoutingRuleListFiltersProps> = ({ displayLegacy }) => (
    <Stack vertical spacing={FILTERS_SPACING}>
        <FormInputField name={RoutingRulesListFilterSchemaKeys.Name} label={lt('Name')} />
        <EnumSelectField
            multiselect
            required
            omitHint
            name={RoutingRulesListFilterSchemaKeys.Timing}
            label={lt('Timing')}
            enumClass={RoutingRuleTriggerType}
            enumPrefix="RoutingRuleTriggerType"
            enabledValues={
                displayLegacy ? undefined : [RoutingRuleTriggerType.Continuous, RoutingRuleTriggerType.Recurring]
            }
        />
        <SearchHookField
            name={RoutingRulesListFilterSchemaKeys.Company}
            label={lt('Company')}
            searchTypes={[SearchType.Company]}
        />
        <SearchHookField
            name={RoutingRulesListFilterSchemaKeys.TravelAgency}
            label={lt('TravelAgency')}
            searchTypes={[SearchType.TravelAgency]}
        />
    </Stack>
);
